export enum TruckSizeRestriction {
  NONE = 'None',
  _40 = '40',
  _48 = '48',
  _53 = '53'
}
